export default "__VITE_ASSET__C3gfmRTh__"